import { setupWorker } from 'msw/browser';
import { handlers } from './handlers';

// MSW sets up a service worker that runs in-browser e.g. it could serve mock data while manually testing
export const worker = setupWorker(...handlers);
